import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate, useParams } from "react-router";

import GaiaDeleteButton from "~/modules/app/components/GaiaDeleteButton";
import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import { SPECIES_LIST_PATH } from "~/modules/settings/constants";

import SpeciesForm, { SpeciesFormInputs } from "../../components/SpeciesForm";
import { useSettingsSpeciesData } from "./hooks/useSettingsSpeciesData";

export default function SettingsSpeciesEditRoute() {
    const { t } = useTranslation("species");
    const navigate = useNavigate();
    const { speciesId } = useParams();

    if (!speciesId) throw Error("no speciesId param in url");

    const { queryData, updateMutation, deleteMutation } = useSettingsSpeciesData(speciesId);

    const handleSubmit = async (data: SpeciesFormInputs) => {
        await updateMutation.updateSpecies(speciesId, data);
        navigate(generatePath(SPECIES_LIST_PATH));
    };

    const handleDelete = async () => {
        await deleteMutation.deleteSpecies(speciesId);
        navigate(generatePath(SPECIES_LIST_PATH));
    };

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("settingsSpeciesEditRoute.title")} isLoading={queryData.loading}>
                {queryData.error && <Alert severity="error">{queryData.error.message}</Alert>}
                {queryData.species && (
                    <SpeciesForm initialData={queryData.species} onSubmit={handleSubmit} error={updateMutation.error} />
                )}
            </GaiaPageComponent>
            <GaiaPageComponent title={t("settingsSpeciesEditRoute.dangerZone")} titleVariant="h3">
                {deleteMutation.error && <Alert severity="error">{deleteMutation.error.message}</Alert>}
                <GaiaDeleteButton
                    label={t("settingsSpeciesEditRoute.speciesDeleteBtn")}
                    onDelete={handleDelete}
                    isLoading={deleteMutation.loading}
                />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
